import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyCU8QAa7L-N0sCwqlEvmVBwlQMzQZNTWcc",
    authDomain: "dalounny-closet.firebaseapp.com",
    databaseURL: "https://dalounny-closet.firebaseio.com",
    projectId: "dalounny-closet",
    storageBucket: "dalounny-closet.appspot.com",
    messagingSenderId: "192015273938",
    appId: "1:192015273938:web:73a380bc80cb5b0cfc820b",
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

// collection references
const categoriesCollection = db.collection("categories");
const productsCollection = db.collection("products");
const productsHistoryCollection = db.collection("products_history");
const paymentsCollection = db.collection("payments");
const increase = (qty) => firebase.firestore.FieldValue.increment(qty);
const decrease = (qty) => firebase.firestore.FieldValue.increment(-qty);

export {
    db,
    auth,
    storage,
    categoriesCollection,
    productsCollection,
    productsHistoryCollection,
    paymentsCollection,
    increase,
    decrease
};
